import { useEffect, useState } from "react";
import axios from "axios";
import { CalendarDays, CheckCircle2, Clock3, MapPin, Users } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const included = [
  "130 ore di formazione abilitante",
  "Materiale didattico incluso",
  "Esame finale davanti alla Commissione",
  "Attestato di abilitazione valido in tutta Italia",
  "Possibilità di frequentare in presenza o online",
];

export default function Prezzo() {
  const [seats, setSeats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/seats`).then((r) => setSeats(r.data)).catch(() => {});
  }, []);

  const facts = [
    { icon: CalendarDays, label: "Prossima edizione", value: "26 Ottobre 2026" },
    { icon: Clock3, label: "Orario lezioni", value: "14:00 – 18:00" },
    { icon: MapPin, label: "Sede", value: "Via Mazzali 5, Milano" },
    {
      icon: Users,
      label: "Disponibilità",
      value: seats ? `${seats.remaining} su ${seats.total} posti rimasti` : "Posti limitati",
      testid: "prezzo-fact-posti",
    },
  ];

  return (
    <section id="prezzo" className="border-t border-line bg-white py-16 md:py-24" data-testid="prezzo-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Trasparenza totale"
          title="Prezzo e scheda del corso"
          sub="Un unico prezzo, tutto incluso: nessun costo nascosto per materiale didattico o esame finale."
          testid="prezzo"
        />
        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <div className="flex h-full flex-col bg-navy p-8 text-white sm:p-10" data-testid="prezzo-card">
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-brand-amber">Quota di partecipazione</p>
              <div className="mt-4 flex items-end gap-2">
                <span className="font-heading text-6xl font-extrabold tracking-tight sm:text-7xl" data-testid="prezzo-value">
                  € 1.000
                </span>
                <span className="pb-2 font-mono text-xs uppercase tracking-wider text-slate-300">totale</span>
              </div>
              <ul className="mt-8 flex-1 space-y-3">
                {included.map((item) => (
                  <li key={item} className="flex gap-3 text-sm text-slate-200">
                    <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-brand-amber" />
                    {item}
                  </li>
                ))}
              </ul>
              {seats && (
                <div className="mt-6 border border-brand-amber/40 bg-brand-amber/10 p-4" data-testid="seats-counter">
                  <div className="flex items-center justify-between font-mono text-[11px] font-medium uppercase tracking-[0.2em] text-brand-amber">
                    <span>Posti rimasti - ed. 26 Ott 2026</span>
                    <span data-testid="seats-remaining">{seats.remaining}/{seats.total}</span>
                  </div>
                  <div className="mt-2 h-1.5 w-full bg-white/10">
                    <div
                      className="h-full bg-brand-amber transition-all duration-700"
                      style={{ width: `${Math.max((seats.remaining / seats.total) * 100, 4)}%` }}
                    />
                  </div>
                </div>
              )}
              <button
                onClick={() => scrollToId("#iscriviti")}
                className="mt-8 bg-brand-amber px-6 py-4 font-heading text-sm font-bold uppercase tracking-wider text-navy-deep transition-colors hover:bg-white hover:text-navy"
                data-testid="prezzo-cta-button"
              >
                Blocca il tuo posto
              </button>
            </div>
          </Reveal>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-7">
            {facts.map((f, i) => (
              <Reveal key={f.label} delay={i * 0.08}>
                <div className="h-full border border-line bg-paper p-7" data-testid={`prezzo-fact-${i}`}>
                  <f.icon className="h-5 w-5 text-brand-amber" />
                  <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">{f.label}</p>
                  <p className="mt-2 font-heading text-xl font-bold tracking-tight text-navy">{f.value}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
